import React from 'react';

interface ProjectProgressBarProps {
  value: number | null;
  variant?: 'default' | 'success' | 'warning' | 'danger';
  showPercentage?: boolean;
}

export const ProjectProgressBar: React.FC<ProjectProgressBarProps> = ({
  value,
  variant = 'default',
  showPercentage = true,
}) => {
  if (value === null || value === undefined) {
    return <span className="progress-na">-</span>;
  }

  const getVariantColor = () => {
    switch (variant) {
      case 'success': return '#22c55e';
      case 'warning': return '#f59e0b';
      case 'danger': return '#ef4444';
      default: return '#3b82f6';
    }
  };

  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className="project-progress-bar">
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{
            width: `${clampedValue}%`,
            backgroundColor: getVariantColor(),
          }}
        />
      </div>
      {showPercentage && (
        <span className="progress-text">{Math.round(value)}%</span>
      )}
      <style>{`
        .project-progress-bar {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 100px;
        }

        .progress-track {
          flex: 1;
          height: 8px;
          background: var(--color-border);
          border-radius: 4px;
          overflow: hidden;
        }

        .progress-fill {
          height: 100%;
          border-radius: 4px;
          transition: width 0.3s ease;
        }

        .progress-text {
          font-size: 0.75rem;
          font-weight: 500;
          min-width: 36px;
          text-align: end;
          color: var(--color-text);
        }

        .progress-na {
          color: var(--color-text-secondary);
        }
      `}</style>
    </div>
  );
};
